import loadSidebar from "../components/sidebar";
import loadMainContent from "../components/mainContent";
import loadCreatingNewtask from "../components/creatingNewTask";

export default function loadDashboardPage() {
    loadSidebar();
    loadMainContent();
    loadCreatingNewtask();
}